<template>
  <div
    class="w-full h-50 border border-gray-400 rounded-md p-4 overflow-hidden relative"
  >
    <button
      class="absolute right-2 top-2 w-8 h-8"
      @click="$emit('deleteProduct')"
    >
      <img src="@/assets/icons/trash.svg" alt="delete" />
    </button>
    <h3>
      {{ product.unificado }}
    </h3>
    <img
      :src="product.thumbnail || product.imageRoute"
      class="h-full mx-auto"
      alt="product image"
      v-if="product.thumbnail || product.imageRoute"
    />
    <div v-else>No image</div>
  </div>
</template>
<script>
export default {
  name: "ProductsVariationItem",
  props: {
    product: {
      type: Object,
      required: true
    }
  }
};
</script>
